import { GET_PARTNER_LINK } from './types';

export const getLinks = prefix => ({
	type: GET_PARTNER_LINK,
	prefix,
});
